import { RestrictedAccountObject } from "./restricted-account-object.model";
import { RestrictedAccountObjectApiFacade } from "./restricted-account-object.api-facade";
import { RestrictedAccountObjectStoreFacade } from "./restricted-account-object.store-facade";
import { AccountObjectFacade } from "../account-object/account-object.facade";

export abstract class RestrictedAccountObjectFacade<T extends RestrictedAccountObject, A extends RestrictedAccountObjectApiFacade<T>, S extends RestrictedAccountObjectStoreFacade<T>> extends AccountObjectFacade<T, A, S> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/restricted-account-object/restricted-account-object.facade.ts